<div class="customer-service-search-border customer-care-multiselect no-padding">
  <div class="col-md-12 no-padding form-horizontal position-relative mt-3">

    <form [formGroup]="fdTicketsForm" novalidate>
      <div class="row no-margin">
        <div class="child_1 col-xs-12 col-lg-6 p-0">
          <label for="ticketNumber"
            class="control-label col-xs-1 col-lg-2  right-padding-0">{{'ticketing-system.Ticket Number' |translate}}</label>
          <div class="col-sm-7 col-md-5 col-lg-8 floating-input floatLabelContainer">
            <input #ticketType id="ticketType" float-label tabindex="0" [(ngModel)]="ticketSearchModel.ticketNumber"
              class="form-control" placeholder="{{'ticketing-system.Ticket #' |translate}}" tabindex="1" type="text" autofocus
              (blur)="searchWithTicketNumber()" (keyup.enter)="onSearch()" formControlName="ticketNumber">
          </div>
          <!-- <div class="col-sm-4 col-md-6 col-lg-7">
                      <span>{{ticketSearchModel.ticketNumber}}</span>
                    </div> -->
        </div>
        <!-- email -->
        <div class="child_2 col-xs-12 col-lg-6" style="padding: 0px;">
          <label for="Email" class="control-label col-xs-1 right-padding-0">{{'ticketing-system.Email' |translate}}</label>
          <div class="col-sm-7 col-md-5 col-lg-8 floating-input floatLabelContainer">
            <input id="email" float-label tabindex="0" class="form-control"
              placeholder="{{'ticketing-system.Email Address' |translate}}" tabindex="1" type="email" autofocus
              (blur)="searchWithTicketNumber()" (keyup.enter)="onSearch()" formControlName="email">
            <div class="alert-msg"
              *ngIf="fdTicketsForm.get('email').hasError('pattern') && fdTicketsForm.get('email').touched">
              {{'validation-message.Enter a valid email address'|translate | translateKey}}
            </div>
          </div>
        </div>
      
      </div>
      <!--Country Office-->
      <div class="row no-margin">
        <label for="ticketNumber"
          class="control-label col-xs-1 right-padding-0">{{'ticketing-system.Country Office' |translate}}</label>
        <div class="col-sm-7 col-md-5 col-lg-4 floating-input floatLabelContainer">
          <angular2-multiselect autofocus tabindex="0" (keyup.enter)="openDropDown('countryassignTo')"
            formControlName="operatingCountryId" id="countryassignTo" [data]="dropdownSettings.countryDropdownList"
            [(ngModel)]="dropdownSettings.countrySelectedItems" [settings]="countryDropdownSettings"
            (onSelect)="onItemSelect($event,dropdownSettings.countryIndex)"
            (onDeSelect)="onItemDeSelect($event,dropdownSettings.countryIndex)"
            (onSelectAll)="onSelectAll($event,dropdownSettings.countryIndex)"
            (onDeSelectAll)="onDeSelectAll($event,dropdownSettings.countryIndex)">
          </angular2-multiselect>
        </div>
        <div class="col-sm-4 col-md-6 col-lg-7"
          *ngIf="countryOnSelectAll && dropdownSettings.countrySelectedItems.length > 0">
          {{'ticketing-system.ALL' |translate | translateKey}}
        </div>
        <div class="col-sm-4 col-md-6 col-lg-7" *ngIf="!countryOnSelectAll">
          <span *ngFor="let countryassignTo of dropdownSettings.countrySelectedItems| slice:0:8 ; let i=index">
            {{countryassignTo.itemName}}
            <span *ngIf="(dropdownSettings.countrySelectedItems.length-1 > i) && !(i > 6)"> | </span>
          </span>
          <span class="addmore-link"
            *ngIf="dropdownSettings.countrySelectedItems.length > 8">{{'ticketing-system.and more' |translate |translateKey}}</span>
        </div>
      </div>

      <!-- assign to user -->
      <div class="row no-margin">
        <label for="{{'ticketing-system.Assign to User' |translate}}"
          class="control-label col-xs-1 right-padding-0">{{'ticketing-system.Assign to User' |translate}}</label>
        <div class="col-sm-7 col-md-5 col-lg-4 floating-input">
          <angular2-multiselect tabindex="0" formControlName="assignTo" (keyup.enter)="openDropDown('teamassignTo')"
            id="teamassignTo" [data]="dropdownSettings.assignedToDropdownList"
            [(ngModel)]="dropdownSettings.assignedToSelectedItems" [settings]="dropdownSettings.settings"
            (onSelect)="onItemSelect($event,dropdownSettings.assignedToIndex)"
            (onDeSelect)="onItemDeSelect($event,dropdownSettings.assignedToIndex)"
            (onSelectAll)="onSelectAll($event,dropdownSettings.assignedToIndex)"
            (onDeSelectAll)="onDeSelectAll($event,dropdownSettings.assignedToIndex)">
          </angular2-multiselect>
        </div>
        <div class="col-sm-4 col-md-6 col-lg-7"
          *ngIf="assignToOnSelectAll && dropdownSettings.assignedToSelectedItems.length > 0">
          {{'ticketing-system.ALL' |translate | translateKey}}
        </div>
        <div class="col-sm-4 col-md-6 col-lg-7" *ngIf="!assignToOnSelectAll">
          <span *ngFor="let teamassignTo of dropdownSettings.assignedToSelectedItems| slice:0:8 ; let i=index">
            {{teamassignTo.itemName}}
            <span *ngIf="(dropdownSettings.assignedToSelectedItems.length-1 > i) && !(i > 6)"> | </span>
          </span>
          <span class="addmore-link"
            *ngIf="dropdownSettings.assignedToSelectedItems.length > 8">{{'ticketing-system.and more' |translate |translateKey}}</span>
        </div>
      </div>

      <!-- status -->
      <div class="row  no-margin">
        <label class="control-label col-xs-1 right-padding-0"
          for="{{'ticketing-system.Status' |translate}}">{{'ticketing-system.Status' |translate}}</label>
        <div class="col-sm-7 col-md-5 col-lg-4 floating-input">

          <angular2-multiselect tabindex="1" (keyup.enter)="openDropDown('status')" id="status"
            [data]="dropdownSettings.statusDropdownList" [(ngModel)]="dropdownSettings.statusSelectedItems"
            [settings]="dropdownSettings.settings" (onSelect)="onItemSelect($event,dropdownSettings.statusIndex)"
            (onDeSelect)="onItemDeSelect($event,dropdownSettings.statusIndex)"
            (onSelectAll)="onSelectAll($event,dropdownSettings.statusIndex)"
            (onDeSelectAll)="onDeSelectAll($event,dropdownSettings.statusIndex)" formControlName="status">
          </angular2-multiselect>

        </div>

        <div class="col-sm-4 col-md-6 col-lg-7" *ngIf="!statusOnSelectAll">
          <span *ngFor="let status of dropdownSettings.statusSelectedItems ; let i=index">{{status.itemName}}
            <span *ngIf="(dropdownSettings.statusSelectedItems.length-1 > i) && !(i > 2)"> | </span>

          </span>
        </div>
        <div class="col-sm-4 col-md-6 col-lg-7"
          *ngIf="statusOnSelectAll && dropdownSettings.statusSelectedItems.length > 0">
          {{'ticketing-system.ALL' |translate | translateKey}}
        </div>

      </div>

      <!-- ticket type -->
      <div class="row  no-margin">
        <label class="control-label col-xs-1 right-padding-0"
          for="{{'ticketing-system.Ticket Type' |translate}}">{{'ticketing-system.Ticket Type' |translate}}</label>
        <div class="col-sm-7 col-md-5 col-lg-4 floating-input">
          <angular2-multiselect tabindex="1" (keyup.enter)="openDropDown('ticketType')" id="ticketType"
            [data]="dropdownSettings.typeDropdownList" [(ngModel)]="dropdownSettings.typeSelectedItems"
            [settings]="dropdownSettings.settings" (onSelect)="onItemSelect($event,dropdownSettings.typeIndex)"
            (onDeSelect)="onItemDeSelect($event,dropdownSettings.typeIndex)"
            (onSelectAll)="onSelectAll($event,dropdownSettings.typeIndex)"
            (onDeSelectAll)="onDeSelectAll($event,dropdownSettings.typeIndex)" formControlName="type">
          </angular2-multiselect>
        </div>
        <div class="col-sm-4 col-md-6 col-lg-7"
          *ngIf="ticketTypeOnSelectAll && dropdownSettings.typeSelectedItems.length > 0">
          {{'ticketing-system.ALL' |translate | translateKey}}
        </div>
        <div class="col-sm-4 col-md-6 col-lg-7" *ngIf="!ticketTypeOnSelectAll ">
          <span
            *ngFor="let ticketType of dropdownSettings.typeSelectedItems| slice:0:8 ; let i=index">{{ticketType.itemName}}
            <span *ngIf="(dropdownSettings.typeSelectedItems.length-1 > i) && !(i > 6)"> | </span>
          </span>

          <span class="addmore-link"
            *ngIf="dropdownSettings.typeSelectedItems.length > 8">{{'ticketing-system.and more' |translate |translateKey}}</span>
        </div>
      </div>

      <!-- subtype -->
      <div class="row  no-margin">
        <label
          class="control-label col-xs-1 right-padding-0">{{'ticketing-system.SubType' |translate |translateKey}}</label>
        <div class="col-sm-7 col-md-5 col-lg-4 floating-input">
          <angular2-multiselect tabindex="1" (keyup.enter)="openDropDown('subType')" id="subType"
            [data]="dropdownSettings.subTypeDropdownList" [(ngModel)]="dropdownSettings.subTypeSelectedItems"
            [settings]="dropdownSettings.settings" (onSelect)="onItemSelect($event,dropdownSettings.subTypeIndex)"
            (onDeSelect)="onItemDeSelect($event,dropdownSettings.subTypeIndex)"
            (onSelectAll)="onSelectAll($event,dropdownSettings.subTypeIndex)"
            (onDeSelectAll)="onDeSelectAll($event,dropdownSettings.subTypeIndex)" formControlName="subType">
          </angular2-multiselect>
        </div>
        <div class="col-sm-4 col-md-6 col-lg-7" *ngIf="!subTypeOnSelectAll">
          <span
            *ngFor="let subType of dropdownSettings.subTypeSelectedItems  | slice:0:8 ; let i=index">{{subType.itemName}}
            <span *ngIf="(dropdownSettings.subTypeSelectedItems.length-1 > i) && !(i > 6)"> | </span>
          </span>

          <span class="addmore-link"
            *ngIf="dropdownSettings.subTypeSelectedItems.length > 8">{{'ticketing-system.and more' |translate |translateKey}}</span>
        </div>
        <div class="col-sm-4 col-md-6 col-lg-7"
          *ngIf="subTypeOnSelectAll && dropdownSettings.subTypeSelectedItems.length > 0">
          {{'ticketing-system.ALL' |translate | translateKey}}
        </div>
      </div>

    </form>

    <!-- excel -->
    <button type="button" tabindex="0" [disabled]="!allTickets.length" (keyup.enter)="Download('CSV')"
      (click)="Download('CSV')" class="myteamTicketsButton">
      <span class="btn-label">
        <img class="excel-image" [src]="excelIconUrl" alt="Excel Icon">
      </span>
    </button>


    <!-- search and clear buttons -->
    <div class="pull-right button-block">
      <button class="btn blue-button" #searchbutton id="search-button" tabindex="0" type="submit"
        [ngClass]="fdTicketsForm.get('ticketNumber').value?.length > 0 ? 'button-active' : 'blue-button'"
        (keyup.enter)="onSearch()" type="button" (click)="onSearch()" 
        [disabled]="((fdTicketsForm.get('ticketNumber').value && fdTicketsForm.get('email').value ) || !fdTicketsForm.valid) ">{{'ticketing-system.Search' |translate}}</button>
      <button class="btn grey-button" tabindex="0" type="button"
        (click)="isClearClicked=true;clearFields()">{{'ticketing-system.CLEAR' | translate | translateKey}}</button>
    </div>

  </div>

  <!-- table -->
  <div class="col-md-12 no-padding card margintop-32">

    <div class="table-responsive">
      <div class="alert-msg text-align-center" *ngIf="isFormInvalid && fdTickets.length>0">
        <span>{{'ticketing-system.Please choose at least one ticket from the list' | translate| translateKey}}</span>
      </div>
      <table class="tickets-display table table-striped custab ticket-dashbaord">
        <thead>
          <tr>
            <th class="width-15">
              <div>
                <input type="checkbox" tabindex="0" [(ngModel)]="selectAll"
                  (change)="onTicketSelect($event,fdTickets,true)">
              </div>
            </th>
            <th class="width-30 pointer" tabindex="0" (keyup.enter)="sortTableByColumn('PRIORITY')"
              (click)="sortTableByColumn('PRIORITY')">{{'ticketing-system.Priority' |translate}}&nbsp;<i class="fa fa-sort"
                [ngClass]="{'fa-sort': sortColumn != 'PRIORITY', 'fa-sort-asc': (sortColumn  == 'PRIORITY' && !isDesc), 'fa-sort-desc': (sortColumn  == 'PRIORITY' && isDesc) }"
                style="font-size:12px"></i>
            </th>

            <th class="width-35 pointer" tabindex="0" (click)="sortTableByColumn('TICKET_NUMBER')">
              {{'ticketing-system.Ticket #' |translate}}&nbsp;<i class="fa fa-sort"
                [ngClass]="{'fa-sort': sortColumn != 'TICKET_NUMBER', 'fa-sort-asc': (sortColumn  == 'TICKET_NUMBER' && !isDesc), 'fa-sort-desc': (sortColumn  == 'TICKET_NUMBER' && isDesc) }"
                style="font-size:12px"></i>

            </th>
            <th>{{'ticketing-system.Subject' |translate}}
            </th>
            <th class="width-30 pointer" tabindex="0" (click)="sortTableByColumn('OPERATING_COUNTRY')">
              {{'ticketing-system.Country' |translate}}&nbsp;<i class="fa fa-sort"
                [ngClass]="{'fa-sort': sortColumn != 'OPERATING_COUNTRY', 'fa-sort-asc': (sortColumn  == 'OPERATING_COUNTRY' && !isDesc), 'fa-sort-desc': (sortColumn  == 'OPERATING_COUNTRY' && isDesc) }"
                style="font-size:12px"></i>

            </th>
            <th class="width-40">{{'ticketing-system.User' |translate}}&nbsp;</th>
            <th class="width-40" > {{'ticketing-system.Type' |translate}}</th>
            <th class="width-40 pointer" (click)="sortTableByColumn('SUBTYPE')">
              {{'ticketing-system.SubType' |translate |titlecase}}&nbsp;<i class="fa fa-sort"
                [ngClass]="{'fa-sort': sortColumn != 'SUBTYPE', 'fa-sort-asc': (sortColumn  == 'SUBTYPE' && !isDesc), 'fa-sort-desc': (sortColumn  == 'SUBTYPE' && isDesc) }"
                style="font-size:12px"></i>
            </th>
            <th class="width-30 pointer" (click)="sortTableByColumn('STATUS')">
              {{'ticketing-system.Status' |translate}}&nbsp;<i class="fa fa-sort"
                [ngClass]="{'fa-sort': sortColumn != 'STATUS', 'fa-sort-asc': (sortColumn  == 'STATUS' && !isDesc), 'fa-sort-desc': (sortColumn  == 'STATUS' && isDesc) }"
                style="font-size:12px"></i>
            </th>
            <th class="width-40 pointer" tabindex="0" (keyup.enter)="sortTableByColumn('CREATED_DATE')"
              (click)="sortTableByColumn('CREATED_DATE')">
              {{'ticketing-system.Created Date' |translate |translateKey}}&nbsp;
              <i class="fa fa-sort"
                [ngClass]="{'fa-sort': sortColumn != 'CREATED_DATE', 'fa-sort-asc': (sortColumn  == 'CREATED_DATE' && !isDesc), 'fa-sort-desc': (sortColumn  == 'CREATED_DATE' && isDesc) }"
                style="font-size:12px"></i>
            </th>
            <th class="width-60 pointer" tabindex="0" (keyup.enter)="sortTableByColumn('UPDATED_DATE')"
              (click)="sortTableByColumn('UPDATED_DATE')">{{'ticketing-system.Last Modified Date' |translate}}&nbsp;
              <i class="fa fa-sort"
                [ngClass]="{'fa-sort': sortColumn != 'UPDATED_DATE', 'fa-sort-asc': (sortColumn  == 'UPDATED_DATE' && !isDesc), 'fa-sort-desc': (sortColumn  == 'UPDATED_DATE' && isDesc) }"
                style="font-size:12px"></i>
            </th>

          </tr>

        </thead>
        <tbody>
          <tr
            *ngFor="let ticket of fdTickets | paginate: {  id: 'fd-tickets-pagination', itemsPerPage: pageSize, currentPage: pageNumber, totalItems: pageCount }">
            <td><input tabindex="0" type="checkbox" value="true" [checked]="ticket.isSelected"
                (change)="onTicketSelect($event,[ticket])"></td>
            <td class="label-center"><span class="label label-default" [class]="ticket.priorityValue.toLowerCase()">&nbsp;&nbsp;&nbsp;&nbsp;</span></td>
            <td *ngIf="isTicketView"><a tabindex="0" (keyup.enter)="goToViewTicket(ticket.id,ticket.ticketNumber,true)"
                (click)="goToViewTicket(ticket.id,ticket.ticketNumber,true)">{{ticket.ticketNumber}}</a></td>
            <td>{{ticket.subject}}</td>
            <td style="text-transform:capitalize;">{{ticket.operatingCountryName}}</td>
            <td>{{ticket.assignedToValue}}</td>
            <td>{{ticket.ticketType}}</td>
            <td>{{ticket.subType}}</td>
            <td>{{ticket.status}}</td>
            <td>{{ticket.createdDate}}</td>
            <td>{{ticket.modifiedDate | date: 'dd-MMM-yyyy'}}</td>
          </tr>
        </tbody>

        <tbody *ngIf="fdTickets?.length === 0">
          <tr>
            <td colspan="11" class="text-center" style="text-align: center">
              {{'ticketing-system.No records found' | translate | translateKey}}.</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="alert-white rounded grid-count">
      <div>
        {{pageCount}} {{'ticketing-system.record(s) found' |translate}}
      </div>
      <pagination-controls [id]="paginationInstance.id" (pageChange)="pageChange($event)" class="pull-right">
      </pagination-controls>
      <div class="pull-left margin_top-5">
        <select tabindex="0" [(ngModel)]="pageSize" class="form-control" (change)="pageChange(1)">
          <option *ngFor="let pageSize of pageSizes" [value]="pageSize">
            {{pageSize}}</option>
        </select>
      </div>
    </div>
  </div>


  <!-- spam ticket -->
  <div *ngIf="ticketSpamOrUnspamForm" class="mb-35">
    <form [formGroup]="ticketSpamOrUnspamForm" novalidate>
      <a *ngIf="dropdownSettings.statusSelectedItems.length === 1 && dropdownSettings.statusSelectedItems[0].id === closed ;else elseBlock"
        (keyup.enter)="selectTicketAsSpamOrUnspam(ticketSpamOrUnspamForm.value)"
        (click)="selectTicketAsSpamOrUnspam(ticketSpamOrUnspamForm.value)">{{'ticketing-system.Mark Selected Tickets as Unspam' |translate}}</a>
      <ng-template #elseBlock><a (keyup.enter)="selectTicketAsSpamOrUnspam(ticketSpamOrUnspamForm.value)"
          (click)="selectTicketAsSpamOrUnspam(ticketSpamOrUnspamForm.value)">{{'ticketing-system.Mark Selected Tickets as Spam' |translate}}</a>
      </ng-template>
    </form>
  </div>

</div>

<modal #spamOrUnspamTicketConfirmationModal>
  <modal-header>
    <h4 class="color-blue">{{'ticketing-system.Confirmation' |translate}}</h4>
  </modal-header>
  <modal-content>
    <div
      *ngIf="dropdownSettings.statusSelectedItems.length === 1 && dropdownSettings.statusSelectedItems[0].id === closed;else elseBlock"
      class="">
      {{'ticketing-system.Are you sure you want to unspam all the selected tickets?' | translate}}
    </div>
    <ng-template #elseBlock>
      <div class="">
        {{'ticketing-system.Are you sure you want to spam all the selected tickets?' | translate}}
      </div>
    </ng-template>
  </modal-content>
  <modal-footer>
    <div class="pull-right">
      <button class="btn blue-button" type="button" tabindex="0" (keyup.enter)="spamorUnspamSelectedTickets()"
        (click)="spamorUnspamSelectedTickets()">
        {{'ticketing-system.Confirm' |translate}}
      </button>
      <button class="btn blue-button" type="button" tabindex="1"
        (keyup.enter)="closeSpamOrUnpsamTicketConfirmationPopup()" (click)="closeSpamOrUnpsamTicketConfirmationPopup()">
        {{'ticketing-system.Cancel' |translate}}
      </button>
    </div>
  </modal-footer>
</modal>



// WEBPACK FOOTER //
// ./src/app/customerservice/templates/template1/views/fd-tickets.component.html